
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/konular/[moduleSlug]",
      function () {
        return require("private-next-pages/konular/[moduleSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/konular/[moduleSlug]"])
      });
    }
  